module.exports = __webpack_public_path__ + "img/core-save.f93da43a.jpg";